import _orderBy from 'lodash/orderBy';
import {TBrandsData, TCharGroupData} from './IBrands';
import {BRANDS_TABS_HEIGHT} from 'brandConstants';

/**
 * Transforms provided brands data into characters map
 * @param {TBrandsData} data - The brands data
 * @returns {TCharGroupData} - The transformed brands data
 */
export function transformBrandsData(data: TBrandsData): TCharGroupData {
	const charsMap: TCharGroupData = new Map();

	if (!data.length) {
		return charsMap;
	}

	const sortedBrands = _orderBy(data, [(brandItem) => brandItem.label.toLowerCase()], ['asc']);

	sortedBrands.forEach((brandItem) => {
		let firstChar = brandItem.label.charAt(0).toLowerCase();

		// If not a letter
		if (!firstChar.match(/[a-z]/i)) {
			firstChar = '#';
		}

		if (!charsMap.has(firstChar)) {
			charsMap.set(firstChar, []);
		}

		const charGroup = charsMap.get(firstChar);

		charGroup?.push(brandItem);
	});

	return charsMap;
}

/**
 * @function
 * @description Gets tabs fixed height based on current viewport breakpoint
 * @param {Boolean} isDesktop - indicates if Desktop layout
 * @returns {Number}
 */
export const getTabsFixedHeight = (isDesktop: boolean): number => {
	return isDesktop ? BRANDS_TABS_HEIGHT.desktop : BRANDS_TABS_HEIGHT.mobile;
};
